var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-spin',{attrs:{"tip":"Processing...","spinning":_vm.spinning}},[_c('CCardBody',{staticClass:"p-0"},[_c('CDataTable',{attrs:{"items":_vm.items,"fields":_vm.fields,"table-filter":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }